import { MathJaxContext } from 'better-react-mathjax';
import React from 'react';

import { MATHJAX_CONFIG, MATHJAX_SRC } from './mathJaxConfig';

type QuizMathJaxProviderProps = {
    children: React.ReactNode;
};

/**
 * Single MathJaxContext for a quiz page/modal. Mount once at the content root;
 * use QuizMathContent per question for typesetting — do not nest providers.
 */
export function QuizMathJaxProvider({ children }: QuizMathJaxProviderProps) {
    return (
        <MathJaxContext version={3} config={MATHJAX_CONFIG} src={MATHJAX_SRC}>
            {children}
        </MathJaxContext>
    );
}

export default QuizMathJaxProvider;
